/* global Intercom */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { detect } from "detect-browser";
import messageType from "./types/messageType";
import MessageLeft from "./Messaging/MessageLeft";
import MessageRight from "./Messaging/MessageRight";
import MessagesForm from "./Messaging/MessagesForm";
import {
  MessagesWrapper,
  MessagesInner,
  MessagesTopBar,
  MessagesContent,
} from "./Messaging/styles/messages-styles";

class CandidateProfileMessages extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    document.body.classList.add("candidate-profile-messages");
    const { scrollToBottom } = this.props;
    scrollToBottom();
    if (typeof Intercom !== "undefined") {
      Intercom("update", { hide_default_launcher: true });
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("candidate-profile-messages");
    if (typeof Intercom !== "undefined") {
      Intercom("update", { hide_default_launcher: false });
    }
  }

  render() {
    const iOS = detect().name === "ios";

    const {
      otherUserName,
      messages,
      userId,
      isEmployer,
      updateStatusLink,
      updateCandidateStatus,
      toggleActionsDropdown,
      actionsDropdown,
      isRejected,
      jobCurrencySymbol,
      jobFilled,
      jobStatus,
      offerMade,
    } = this.props;

    const messageHeader = `${
      isEmployer ? "Recruiter" : "Employer"
    }: ${otherUserName}`;

    return (
      <MessagesWrapper iOS={iOS}>
        <MessagesInner iOS={iOS}>
          <MessagesTopBar>{messageHeader}</MessagesTopBar>
          <MessagesContent id="wrapper" iOS={iOS}>
            {messages.map((message) => {
              const {
                attachment_link: attachmentLink,
                attachment_name: attachmentName,
              } = message;

              if (userId === message.author.company_id) {
                return (
                  <MessageRight
                    action={message.action}
                    actionAt={message.action_at}
                    key={message.id}
                    author={message.author}
                    avatar={message.author.avatar_url}
                    jobCurrencySymbol={jobCurrencySymbol}
                    finalSalary={message.final_salary}
                    textContent={message.message}
                    time={message.created_at}
                    attachmentLink={attachmentLink}
                    attachmentName={attachmentName}
                  />
                );
              }
              return (
                <MessageLeft
                  action={message.action}
                  actionAt={message.action_at}
                  key={message.id}
                  author={message.author}
                  avatar={message.author.avatar_url}
                  jobCurrencySymbol={jobCurrencySymbol}
                  finalSalary={message.final_salary}
                  textContent={message.message}
                  time={message.created_at}
                  attachmentLink={attachmentLink}
                  attachmentName={attachmentName}
                />
              );
            })}
            <div id="scroller" />
          </MessagesContent>
          <MessagesForm
            updateStatusLink={updateStatusLink}
            offerMade={offerMade}
            jobFilled={jobFilled}
            updateCandidateStatus={updateCandidateStatus}
            toggleActionsDropdown={toggleActionsDropdown}
            actionsDropdown={actionsDropdown}
            isEmployer={isEmployer}
            isRejected={isRejected}
            jobCurrencySymbol={jobCurrencySymbol}
            jobStatus={jobStatus}
          />
        </MessagesInner>
      </MessagesWrapper>
    );
  }
}

CandidateProfileMessages.propTypes = {
  otherUserName: PropTypes.string.isRequired,
  messages: PropTypes.arrayOf(messageType).isRequired,
  userId: PropTypes.number.isRequired,
  isEmployer: PropTypes.bool.isRequired,
  scrollToBottom: PropTypes.func.isRequired,
  updateStatusLink: PropTypes.string,
  updateCandidateStatus: PropTypes.func.isRequired,
  toggleActionsDropdown: PropTypes.func.isRequired,
  actionsDropdown: PropTypes.bool.isRequired,
  isRejected: PropTypes.bool.isRequired,
  jobCurrencySymbol: PropTypes.string.isRequired,
  jobStatus: PropTypes.string.isRequired,
  offerMade: PropTypes.bool.isRequired,
  jobFilled: PropTypes.bool,
};

CandidateProfileMessages.defaultProps = {
  jobFilled: PropTypes.isNull,
  updateStatusLink: PropTypes.isNull,
};

export default CandidateProfileMessages;
